import { TOGGLE_SIDEBAR } from "actions/sidebar";

const initialState = true;

export default function(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return !state;
    default:
      return state;
  }
}
